import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';
import { ConfiguredToastrService } from '../helper/toastr/configured-toastr.service';
import { ProjectCommunicationService } from '../communication/project-comms.service';
import { SimulationPostPack } from '../models/results/sim-progress/simulation-post-pack.model';
import { SimulationProgress } from '../models/results/sim-progress/simulation-progress.model';
import { AnessaTranslationService } from '../helper/translation/anessa-translation.service';

@Injectable({
  providedIn: 'root'
})
export class ProgressService implements OnDestroy {
  progressNotifier = new BehaviorSubject<SimulationProgress | null>(null);
  private onDestroyNotifier = new Subject<boolean>();

  constructor(private projectCommService: ProjectCommunicationService,
              private toastrService: ConfiguredToastrService,
              public translationService: AnessaTranslationService
  ) {
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next(true);
    this.onDestroyNotifier.unsubscribe();
  }


  public scheduleSimulationProgress(postPack: SimulationPostPack) {
    if (postPack.id) {
      this.projectCommService.setSimProgress(new SimulationProgress(
        {
          simRunning: true,
          percent: 0,
        }));
    }
  }

  isRunning() {
    const plantSimProgress = this.projectCommService.getSimProgress();
    return plantSimProgress && plantSimProgress.simRunning;
  }

  restartSimulation(postPack: SimulationPostPack) {
    this.projectCommService.setSimProgress(new SimulationProgress());
    this.toastrService.info(this.translationService.get('SERVICE.PROGRESS.RESTART_INITIATED'));
    // this.scheduleSimulation(postPack);
  }
}
